import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { GlobalMessageService, TranslationService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { CustomerIdService } from 'src/app/services/feature/customerId/customer-id.service';
import { kbBrakeAppService } from 'src/app/services/feature/kb-brakeApplication/KbBrakeApplication.service';
import { adminsearchCommentPopup } from '../brake-admin-search-form/adminSearchCommentPopup.component';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { EnggReviewPopupComponent } from './engg-review-popup/engg-review-popup.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-kb-brake-app-search-form',
  templateUrl: './kb-brake-app-search-form.component.html',
  styleUrls: ['./kb-brake-app-search-form.component.scss'],
  providers: [DatePipe],
  standalone: false
})
export class KbBrakeAppSearchFormComponent {

  BrakeRequestsApiData: any;
  canLoadPage: boolean = false;
  customerIdFromCommonEnd: any;
  today: Date = new Date();
  baseUrl: string = '';
  selectedUid: any;
  sortByDate: string = 'desc';
  isMobile: boolean = false;
  sub = new Subscription();
  showChild: boolean = false;
  payLoad: any;
  dateFormat: string = ''

  //Method to initialize the form
  warrantyClaimSearchForm = new FormGroup({
    defaultSoldTo: new FormControl(null, { validators: Validators.required }),
    startDate: new FormControl(null, { validators: Validators.required }),
    endDate: new FormControl(null, { validators: Validators.required }),
    claimNumber: new FormControl(null),
    coWorkerFlag: new FormControl(false),

  });
  showcoWorkerFlag: boolean = true;
  get warrentyform() {
    return this.warrantyClaimSearchForm.controls;
  }
  platformId = inject(PLATFORM_ID);
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  constructor(
    public service: kbBrakeAppService,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
    private custIdService: CustomerIdService,
    private router: Router,
    private translator: TranslationService
  ) {
    this.sub.add(
      this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
        this.isMobile = result.matches;
      })
    );
    this.baseUrl = this.service.occ.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnInit(): void {

    this.sub.add(this.service.searchBrakeAppGetApi().subscribe((res: any) => {
      this.canLoadPage = true;
      this.showcoWorkerFlag = res?.coWorkerFlag;
      this.customerIdFromCommonEnd = this.custIdService?.customerIdData?.b2bUnitsWSList;
      this.selectedUid = res.defaultSoldTo;
      this.setCustomerId(this.selectedUid);
      const startDate = new Date(res.startDate);
      const endDate = new Date(res.endDate);

      this.warrentyform.startDate.setValue(startDate);
      this.warrentyform.endDate.setValue(endDate);
      this.cdr.detectChanges();
    }));
    if (this.isMobile) {
      this.setCustomWidth();
    }
  }
  setCustomerId(uid: any) {
    this.customerIdFromCommonEnd.map((item) => {
      if (item.uid == uid) {
        this.sub.add(this.translator.translate(item.salesArea2).subscribe((resultedString: string) => {
          const soldToData = `${item.salesArea1} | ${resultedString} | ${item.salesArea3}`;
          this.warrentyform.defaultSoldTo.setValue(soldToData);
        }));
      }
    })
  }
  onSubmit(): void {
    this.postWarrantyData(0, 'byCreationDateDesc');
  }
  postWarrantyData(currentPage?, sortType?) {
    const endDate = new Date(this.warrentyform.endDate.value);
    const startDate = new Date(this.warrentyform.startDate.value);
    this.payLoad = {
      defaultSoldTo: this.selectedUid,
      endDate: `${endDate.getMonth() + 1}/${endDate.getDate()}/${endDate.getFullYear()}`,
      startDate: `${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()}`,
      coWorkerFlag: this.warrentyform.coWorkerFlag.value,
      claimNumber: this.warrentyform.claimNumber.value ? this.warrentyform.claimNumber.value.toString().trim() : ''
    }
    this.sub.add(this.service.searchBrakeAppPostApi(this.payLoad, currentPage, sortType).subscribe((res: any) => {
      if (res.message.status == 'SUCCESS') {
        this.BrakeRequestsApiData = res;
        this.dateFormat = this.BrakeRequestsApiData.dateFormat
        this.cdr.detectChanges();
      }
    }));
  }

  showSearchResults($event: Event) {
    $event.stopPropagation();
    this.showChild = !this.showChild;
  }

  receiveData(data: any) {
    this.showChild = false;
    this.selectedUid = data;
    this.setCustomerId(this.selectedUid);
  }
  sort() {
    let payload;
    if (this.sortByDate == 'asc') {
      this.sortByDate = 'desc';
      payload = 'byCreationDatedesc';
    } else {
      this.sortByDate = 'asc';
      payload = 'byCreationDate';
    }
    this.postWarrantyData(0, payload);
  }
  downloadZip(byteArray: any, name: string) {
    try {
      const decodedByteArray = atob(byteArray);
      const zipArray = new Uint8Array(decodedByteArray.length);
      for (let i = 0; i < decodedByteArray.length; i++) {
        zipArray[i] = decodedByteArray.charCodeAt(i);
      }
      if (isPlatformBrowser(this.platformId)) {
        const zipBlob = new Blob([zipArray], { type: 'application/zip' });
        const zipUrl = window.URL.createObjectURL(zipBlob);

        const link = document.createElement('a');
        link.href = zipUrl;
        link.download = name + '.zip';
        link.click();

        this.cleanupDownloadUrl(zipUrl);
      }
    } catch (error) {
      console.error('Error downloading ZIP file:', error);
    }
  }

  private cleanupDownloadUrl(url: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.timeout = setTimeout(() => window.URL.revokeObjectURL(url), 0);
    }
  }
  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const widthInPixels = window.innerWidth - 10;
      document.documentElement.style.setProperty('--custom-table-width', `${widthInPixels}px`);
    }
  }
  openComments(comments: any) {
    this.dialog.open(adminsearchCommentPopup, { data: comments });
  }
  openPopup(code) {
    this.dialog.open(EnggReviewPopupComponent, { data: code })

  }
  navigateToFormPage(code) {
    this.router.navigate(['bendixADBPage'], {
      queryParams: { code: code },
    });
  }
  navigateToUpdatePage(code, status) {
    if (status == "AWAITING") {
      this.dialog.open(EnggReviewPopupComponent, { data: code })
    } else {
      this.router.navigate(['bendixADBUpdatePage'], {
        queryParams: { code: code },
      });
    }

  }
  setvaluevice() {
    if (this.warrentyform.coWorkerFlag.value) {
      this.warrentyform.coWorkerFlag.setValue(false);
    } else {
      this.warrentyform.coWorkerFlag.setValue(true);
    }
    this.cdr.detectChanges();
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.sub.unsubscribe();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

}
